<template>
  <!-- 订单详情价格信息 -->
  <div class="det_price">
    <div
      class="order_id font12 font_weight500 colo087 line_height_17 text_left"
    >
      <div>商品总额</div>
      <div>{{ getUserOrder.orderMoney | currency(false) }}</div>
    </div>
    <div
      class="order_id font12 font_weight500 colo087 line_height_17 text_left"
    >
      <div>税率费用</div>
      <div>{{ getUserOrder.taxMoney | currency(false) }}</div>
    </div>
    <div
      class="order_id font12 font_weight500 colo087 line_height_17 text_left"
    >
      <div>运费</div>
      <div v-if="getUserOrder.freightMoney">
        {{ getUserOrder.freightMoney | currency(false) }}
      </div>
      <div v-if="!getUserOrder.freightMoney">免运费</div>
    </div>
    <!-- <div
      class="order_id font12 font_weight500 colo087 line_height_17 text_left"
    >
      <div>活动扣减</div>
      <div>-¥30</div>
    </div> -->
    <!-- <div
      class="order_id font12 font_weight500 colo087 line_height_17 text_left"
    >
      <div>优惠券</div>
      <div>-¥20</div>
    </div> -->
    <div
      class="order_total order_id font16 font_weight500 colo087 line_height_22 text_left"
    >
      <div>应付金额</div>
      <div class="font_weight600 total_price">
        {{ getUserOrder.total | currency(false) }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    getUserOrder() {
      return this.$store.getters.getUserOrder;
    }
  }
};
</script>

<style lang="less" scoped>
.det_price {
  background: #fff;
  margin: 12px 0 68px;
  padding: 12px 12px 0;
  .order_id {
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding-bottom: 12px;
  }
  .order_total {
    .total_price {
      color: #fd5130;
    }
  }
}
</style>
